<template>
  <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.23484 0.939331L9.84936 7.55385L9.64111 7.76099L9.67529 7.79459L3.06077 14.4091L0.939453 12.2878L5.63911 7.58699L1.11352 3.06065L3.23484 0.939331Z" fill="#292929"/>
  </svg>
</template>